import { render, staticRenderFns } from "./DatosReciboInternauto.vue?vue&type=template&id=a40a67ac&scoped=true&"
import script from "./DatosReciboInternauto.vue?vue&type=script&lang=js&"
export * from "./DatosReciboInternauto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40a67ac",
  null
  
)

export default component.exports